module.exports = __webpack_public_path__ + "img/util-tab-4-title.678123c8.svg";